/**
 * Returns today's date in 'YYYY-MM-DD' format.
 * Useful for matching backend date formats or setting input defaults.
 */
export const getTodayDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

/**
 * Formats a date string into a readable format (e.g., '29 Des 2025').
 * Uses Indonesian locale by default.
 * @param {string|Date} dateValue - The date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (dateValue, options = {}) => {
    if (!dateValue) return "-";
    const date = new Date(dateValue);

    // Check if date is valid
    if (isNaN(date.getTime())) return "-";

    const defaultOptions = {
        day: "2-digit",
        month: "short",
        year: "numeric",
    };

    return new Intl.DateTimeFormat("id-ID", {
        ...defaultOptions,
        ...options,
    }).format(date);
};
